import RouteErrorBoundary from 'components/ErrorBoundary/RouteErrorBoundary'
import RequirePrivilegeLevel from 'components/RequirePrivilegeLevel/RequirePrivilegeLevel'
import PreviewBadge from 'components/PreviewBadge/PreviewBadge'
import ScrollToTop from 'components/ScrollToTop/ScrollToTop'
import SidebarMenu from 'components/SidebarMenu/SidebarMenu'

import ContentOverlay from 'containers/ContentOverlay/ContentOverlayContainer'
import Header from 'containers/Header/Header'
import { HeaderSearchProvider } from 'providers/HeaderSearchProvider'
import { OrganisationsProvider } from 'providers/OrganisationsProvider'
import { BossFilterProvider } from 'providers/BossFilterProvider'
import { GoogleMapsLoadedProvider } from 'providers/GoogleMapsLoadedProvider'
import { SidebarMenuProvider } from 'providers/SidebarMenuProvider'
import React from 'react'
import { Suspense } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Navigate, Route, Routes } from 'react-router'
import { ADMIN_PRIVILEGE_LEVEL, SUPER_ADMIN_PRIVILEGE_LEVEL } from 'utils/privilegeLevel'
const NewNotifications = React.lazy(() => import('routes/NewNotifications'))

const NotificationsContainer = React.lazy(
  () => import('containers/Notifications/NotificationsContainer'),
)
const UserSettingsContainer = React.lazy(
  () => import('components/UserSettings/containers/UserSettingsContainer'),
)
const NotFound = React.lazy(() => import('routes/404'))
const AdminView = React.lazy(() => import('routes/AdminView/AdminView'))
const Dashboard = React.lazy(() => import('routes/Dashboard/Dashboard'))

const FileImportListView = React.lazy(() => import('routes/FileImportListView/FileImportListView'))
const FileImportView = React.lazy(() => import('routes/FileImportView/FileImportView'))
const PersonsView = React.lazy(() => import('routes/PersonView/PersonView'))
const RulesView = React.lazy(() => import('routes/RuleView/RuleViewContainer'))
const TerminalView = React.lazy(() => import('routes/TerminalView/TerminalView'))
const GeoFenceView = React.lazy(() => import('routes/GeoFenceView/GeoFenceView'))

const SuperAdminView = React.lazy(() => import('routes/SuperAdminView/SuperAdminView'))

export interface IAppLayout {
  changePassword: number
}
const AppLayout: React.FC<IAppLayout> = (props) => {
  return (
    <div className="min-h-full bg-[#edf2f7]">
      <SidebarMenuProvider>
        <OrganisationsProvider>
          <BossFilterProvider>
          <GoogleMapsLoadedProvider>
            <HeaderSearchProvider>
              <Header />
              <SidebarMenu />
              <ContentOverlay />
            </HeaderSearchProvider>
            <div className="h-[75px] w-full" />
            <div className="flex flex-row ">
              <div className="sm:w-[75px]" />
              <div className="flex-1 min-w-0">
                <PreviewBadge />
                <ScrollToTop>
                  <Suspense fallback={<Skeleton count={10} />}>
                    <Routes>
                      {Boolean(props.changePassword) && <Route path="/" element={<Navigate to="/userSettings" replace />} />}
                      <Route path="/terminals/:id" element={<RouteErrorBoundary><TerminalView /></RouteErrorBoundary>} />
                      <Route path="/notifications" element={<RouteErrorBoundary><NotificationsContainer /></RouteErrorBoundary>} />
                      <Route path="/newNotifications/*" element={<RouteErrorBoundary><NewNotifications /></RouteErrorBoundary>} />
                      <Route path="/persons" element={<RouteErrorBoundary><PersonsView /></RouteErrorBoundary>} />
                      <Route path="/rules" element={<RouteErrorBoundary><RulesView /></RouteErrorBoundary>} />
                      <Route path="/geofences" element={<RouteErrorBoundary><GeoFenceView /></RouteErrorBoundary>} />
                      <Route path="/admin" element={<RouteErrorBoundary><RequirePrivilegeLevel level={ADMIN_PRIVILEGE_LEVEL}><AdminView /></RequirePrivilegeLevel></RouteErrorBoundary>} />
                      <Route path="/fileimports/:id" element={<RouteErrorBoundary><FileImportView /></RouteErrorBoundary>} />
                      <Route path="/fileimports" element={<RouteErrorBoundary><FileImportListView /></RouteErrorBoundary>} />
                      <Route path="/userSettings" element={<RouteErrorBoundary><UserSettingsContainer /></RouteErrorBoundary>} />

                      <Route path="/superadmin/*" element={<RouteErrorBoundary><RequirePrivilegeLevel level={SUPER_ADMIN_PRIVILEGE_LEVEL}><SuperAdminView /></RequirePrivilegeLevel></RouteErrorBoundary>} />

                      <Route path="/" element={<RouteErrorBoundary><Dashboard /></RouteErrorBoundary>} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Suspense>
                </ScrollToTop>
              </div>
            </div>
          </GoogleMapsLoadedProvider>
        </BossFilterProvider>
        </OrganisationsProvider>
      </SidebarMenuProvider>
    </div>
  )
}

export default AppLayout
